import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import CustomDatePickerInput from 'components/DateField/CustomDatePickerInput';
import styles from '../DateField.module.scss';
import isBefore from 'date-fns/isBefore';
import cn from 'classnames';

class DateFieldRange extends Component {
  state = {
    editInProgress: false,
  };
  startDateRef = React.createRef();
  endDateRef = React.createRef();

  componentDidUpdate(prevProps) {
    if (
      this.state.editInProgress &&
      prevProps.startDateValue !== this.props.startDateValue &&
      this.props.startDateValue
    ) {
      this.openEndDatePopup();
    }
  }

  openEndDatePopup = () => {
    this.setState({ editInProgress: false });
    this.endDateRef.current.setOpen(true);
    this.startDateRef.current.setOpen(false);
    this.endDateRef.current.input.inputRef.current.input.focus();
  };
  setStartDateHandle = (value) => {
    const { handleChangeStart, handleChangeEnd } = this.props;
    handleChangeEnd(null);
    handleChangeStart(value);
    this.setState({ editInProgress: true });
  };

  setEndDateHandle = (value) => {
    const { handleChangeEnd, handleChangeStart, startDateValue, endDateValue } = this.props;
    if (isBefore(value, startDateValue)) {
      if (endDateValue) {
        handleChangeStart(value);
        return;
      }
      this.setStartDateHandle(value);
      return;
    }
    handleChangeEnd(value);
  };

  onBlur = () => {
    const { startDateValue, endDateValue } = this.props;
    return [startDateValue, endDateValue];
  };

  render() {
    const {
      isRequired,
      startDateValue,
      endDateValue,
      dateToString,
      isDisabled,
      className,
      monthsShown,
      minDate,
      maxDate,
      onBlur,
      dateFormat,
      ...props
    } = this.props;
    return (
      <div className={styles.dateRange}>
        <DatePicker
          ref={this.startDateRef}
          selected={startDateValue}
          value={dateToString(startDateValue)}
          selectsStart
          startDate={startDateValue}
          endDate={endDateValue}
          minDate={minDate}
          maxDate={endDateValue || maxDate}
          onChange={this.setStartDateHandle}
          customInput={<CustomDatePickerInput mask={'с 11.11.1111'} tabIndex={0} />}
          dateFormat={'с dd.MM.yyyy'}
          disabled={isDisabled}
          className={cn([styles.dateStart, className])}
          monthsShown={2}
          onBlur={this.onBlur}
          {...props}
        />
        <DatePicker
          ref={this.endDateRef}
          selected={endDateValue}
          value={dateToString(endDateValue)}
          selectsEnd
          startDate={startDateValue}
          endDate={endDateValue}
          minDate={startDateValue || minDate}
          maxDate={maxDate}
          onChange={this.setEndDateHandle}
          customInput={<CustomDatePickerInput mask={'по 11.11.1111'} tabIndex={1} />}
          dateFormat={'по dd.MM.yyyy'}
          popperModifiers={{
            offset: {
              enabled: true,
              offset: `-160px, 0px`,
            },
          }}
          disabled={isDisabled}
          className={cn([styles.dateEnd, className])}
          monthsShown={2}
          onBlur={this.onBlur}
          {...props}
        />
      </div>
    );
  }
}
DateFieldRange.propTypes = {
  startDateValue: PropTypes.object,
  endDateValue: PropTypes.object,
  dateToString: PropTypes.func,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  handleChangeStart: PropTypes.func,
  handleChangeEnd: PropTypes.func,
  className: PropTypes.string,
  monthsShown: PropTypes.number,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onBlur: PropTypes.func,
  dateFormat: PropTypes.string,
};

export default DateFieldRange;
